/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';

import Splide from '../vendors/splide.min';
import SplideExtension from '../vendors/splide-extension-auto-scroll.min';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );
jQuery( function() {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--lh_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Image slider
	 */
	if ( jQuery( '.image-slider-01' ).length > 0 ) {
		jQuery( '.image-slider-right .swiper-wrapper' ).after( `
		    <div class="swiper-bottom">
		        <div class="swiper-pagination"></div>
		        <div class="swiper-arrows">
		            <div class="swiper-button-prev"></div>
		            <div class="swiper-button-next"></div>
		        </div>
		    </div>
		` );
		const swiper = new Swiper( '.image-slider-01', {
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			spaceBetween: 12,
			pagination: {
				el: '.swiper-pagination',
				type: 'progressbar',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );
	}

	if ( jQuery( '.hero-slider-images' ).length > 0 ) {
		const swiper = new Swiper( '.hero-slider-images', {
			slidesPerView: 1,
			loop: true,
			slidesPerGroup: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );
	}

	if ( jQuery( '.image-alongside-text-slider' ).length > 0 ) {
		const swiper = new Swiper( '.image-alongside-text-slider', {
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );
	}

	if ( jQuery( '.event-slider-single' ).length > 0 ) {
		jQuery( '.event-slider-single' ).each( function() {
			const $eventSliderTabs = jQuery( this ).find( '.event-slider' );
			const $items = $eventSliderTabs.children();

			if ( $items.length < 4 ) {
				while ( $eventSliderTabs.children().length < 4 ) {
					$eventSliderTabs.append( $items.clone() );
				}
			} else if ( $items.length === 4 ) {
				$eventSliderTabs.append( $items.clone() );
			}

			$eventSliderTabs.slick( {
				slidesToShow: 3,
				centerMode: true,
				centerPadding: '0px',
				arrows: true,
				infinite: true,
				touchThreshold: 30,
				responsive: [
					{
						breakpoint: 747,
						settings: {
							slidesToShow: 1,
						},
					},
				],
			} );
		} );
	}

	if ( jQuery( '.hero-slider-content' ).length ) {
		jQuery( '.hero-slider-content' ).each( function() {
			const bg = jQuery( this ).closest( '.ctn' ).css( 'background-color' );
			if ( bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent' ) {
				jQuery( this ).css( '--after-bg', bg );
			}
		} );
	}

	if ( jQuery( '#logo-slider' ).length ) {
		const marqueeSlider = new Splide( '#logo-slider', {
			type: 'loop',
			arrows: false,
			pagination: false,
			perMove: 6,
			perPage: 6,
			autoWidth: true,
			gap: '73px',
			drag: true,
			autoScroll: {
				speed: 0.5,
			},
			breakpoints: {
				0: {
					autoplay: false,
				},
				768: {
					gap: '35px',
					autoWidth: true,
					autoplay: true,
					perPage: 1,
					autoScroll: {
						speed: 0.5,
					},
				},
			},
		} );

		marqueeSlider.mount( {
			AutoScroll: window.splide.Extensions.AutoScroll,
		} );
	}

	if ( jQuery( '.tabbed-map-items' ).length > 0 ) {
		jQuery( '.tabbed-map-nav a' ).on( 'click', function( event ) {
			event.preventDefault();
			const tabId = jQuery( this ).attr( 'href' );
			jQuery( '.tabbed-id-item' ).hide().removeClass( 'active' );
			jQuery( `.tabbed-id-item${ tabId }` ).fadeIn( 400 ).addClass( 'active' );
			jQuery( '.tabbed-map-nav a' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			setTimeout( function() {
				jQuery( '.event-slider' ).slick( 'setPosition' );
			}, 410 );
		} );
	}

	jQuery( '.hero-home .hero-home-content li' ).each( function( index ) {
		const ids = [ 'dine', 'drink', 'do' ];
		jQuery( this ).find( 'a' ).attr( 'id', ids[ index ] );
		jQuery( this ).find( 'a' ).addClass( 'tab' );
	} );

	jQuery( '.hero-home .hero-home-content li a' ).on( 'mouseenter', function() {
		const tabId = jQuery( this ).attr( 'id' );
		jQuery( '.hero-home-content .tab,.hero-home-content li a, .hero-home-images .hero-home-image' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		jQuery( '.hero-home-images .hero-home-image#' + tabId ).addClass( 'active' );
	} );

	jQuery( '.hero-home .hero-home-content li a' ).on( 'mouseleave', function() {
		jQuery( '.hero-home-content .tab,.hero-home-content li a, .hero-home-images .hero-home-image' ).removeClass( 'active' );
	} );

	/**
	 * Toggle menu for mobile
	 */

	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	jQuery( '.menu-button-inner' ).on( 'click', function() {
		const header = jQuery( '.header-section' );

		if ( ! header.hasClass( 'white-header' ) ) {
			if ( header.hasClass( 'transparent-header' ) ) {
				header.removeClass( 'transparent-header' ).addClass( 'color-header' );
			} else {
				header.removeClass( 'color-header' ).addClass( 'transparent-header' );
			}
		}
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.mega-menu' ).toggleClass( 'active' );
		jQuery( '.menu-btn' ).toggleClass( 'active' );
		jQuery( '.header-section' ).toggleClass( 'bg-color' );
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( function() {
		jQuery( '.footer-nav .menu-item-has-children' ).on( 'click', function( e ) {
			e.preventDefault();
			const submenu = jQuery( this ).children( '.sub-menu' );
			if ( submenu.is( ':visible' ) ) {
				submenu.slideUp();
			} else {
				submenu.slideDown();
			}
		} );
	} );

	jQuery( '.mega-menu-item' ).each( function() {
		const $menuItem = jQuery( this );
		const $heading = $menuItem.find( '.heading-4' );
		const $submenu = $menuItem.find( '.sub-menu' );

		if ( $submenu.length ) {
			$heading.on( 'click', function( e ) {
				e.preventDefault();

				const $this = jQuery( this );
				const $submenuNext = $this.next( '.sub-menu' );
				const parentId = $this.parent().attr( 'id' );
				const $menuImage = jQuery( '.mega-menu-image#' + parentId );
				const $megaMenuInner = jQuery( '.mega-menu-inner' );

				// Collapse all other submenus and deactivate other headings
				jQuery( '.mega-menu-item .sub-menu' ).not( $submenuNext ).slideUp( 500 );
				jQuery( '.mega-menu-item .heading-4' ).not( $this ).removeClass( 'active' );

				// Toggle current submenu and heading
				$submenuNext.slideToggle( 500 );
				$this.toggleClass( 'active' );

				// Handle menu image transitions
				jQuery( '.mega-menu-image' ).not( $menuImage ).fadeOut( 400 ).removeClass( 'active' );
				if ( ! $menuImage.hasClass( 'active' ) ) {
					$menuImage.fadeIn( 400 ).addClass( 'active' );
					$megaMenuInner.addClass( 'current' );
				} else {
					$menuImage.fadeOut( 400 ).removeClass( 'active' );
					$megaMenuInner.removeClass( 'current' );
				}
			} );
		}
	} );

	/**
	 * Script for Accessibility of html Tags
	 */
	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );
	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );
	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();
	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 7 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

	const indicator = document.querySelector( '.nav-indicator' );
	const items = document.querySelectorAll( '.dropdown-list-title a' );
	const list = document.querySelector( '.select-dropdown-list' );

	function handleIndicator( el ) {
		items.forEach( ( item ) => {
			item.classList.remove( 'is-active' );
			item.removeAttribute( 'style' );
		} );

		const listRect = list.getBoundingClientRect();
		const elRect = el.getBoundingClientRect();

		indicator.style.width = `${ elRect.width + 1 }px`;
		indicator.style.left = `${ ( elRect.left - listRect.left ) }px`;

		el.classList.add( 'is-active' );
	}

	items.forEach( ( item ) => {
		item.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			handleIndicator( item );
		} );

		if ( item.classList.contains( 'is-active' ) ) {
			handleIndicator( item );
		}
	} );
} );

